import React from 'react'
import styled from 'styled-components'
import { device } from '../../../../config/theme/breakpoints'

const GeneralCenter = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const ContainerParcelService = styled(GeneralCenter)`
    justify-content: flex-start;
    border-radius: 50%;
    width: 100%;
    padding: 8px 15px;
    margin-bottom: 10px;

    @media ${device.tablet}{
        width: 50%;
    }
`
const ContainerText = styled.div`
    > h3{
        color: ${p => p.theme.palette.text.primary};
    }

    > p{
        font-size: 13px;
    }
`
const ContainerRadius = styled(GeneralCenter)`
    background: linear-gradient(135deg, rgba(225,49,40,1) 0%, rgba(225,49,40,1) 51%, rgba(254,165,0,1) 52%, rgba(254,165,0,1) 100%);
    border-radius: 50%;
    width: 80px;
    height: 80px;
    flex-direction: row;
    margin-right: 20px;
    
    > div {
        border-radius: 50%;
        background: white;
        width: 94%;
        height: 94%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    > div img{
        max-width: 50px;
    }
`

interface IOwnProps{
    image: string;
    title: string;
    description: string;
}

const ParcelServiceItem: React.FunctionComponent<IOwnProps> = ({
    image,
    title,
    description
}) => {
  return (
    <ContainerParcelService>
        <div>
            <ContainerRadius>
                <div>
                    <img src={image} alt='parcel' />
                </div>
            </ContainerRadius>
        </div>
        <ContainerText>
            <h3>{title}</h3>
            <p>{description}</p>
        </ContainerText>
    </ContainerParcelService>
  )
}

export default ParcelServiceItem